/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/range_max.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the maximum (end) value of a range. For a range [x, y), it returns y.',
  examples: [
    'FROM decades\n| WHERE decade == 1900\n| EVAL max_bound = RANGE_MAX(date_range)\n| KEEP date_range, max_bound',
  ],
  params: {
    range: 'Range expression. If `null`, the function returns `null`.',
  },
};

export default docs;
